/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_KeyboardsInputs */

const he_home_category_keyboards = /** @type {(inputs: Home_Category_KeyboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מקלדות`)
};

const en_home_category_keyboards = /** @type {(inputs: Home_Category_KeyboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyboards`)
};

/**
* | output |
* | --- |
* | "Keyboards" |
*
* @param {Home_Category_KeyboardsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_keyboards = /** @type {((inputs?: Home_Category_KeyboardsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_KeyboardsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_keyboards(inputs)
	return en_home_category_keyboards(inputs)
});